import { SettingsEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getAll = async (): Promise<any> =>
  APIManager.sendGet(
    SettingsEnds.GET_ALL_AI_USE_CATEGORIES,
    true,
    {},
    {},
    axios
  );

const updateCategoryStatus = async (
  id: string,
  isEnabled: boolean
): Promise<any> =>
  APIManager.sendPut(
    SettingsEnds.UPDATE_CATEGORY_STATUS,
    { categoryId: id, is_enabled: isEnabled },
    true,
    {},
    {},
    axios
  );

const getModulesSummary = async (): Promise<any> =>
  APIManager.sendGet(SettingsEnds.MODULE_SUMMARY, true, {}, {}, axios);

const freshDeskLogin = async (data: any): Promise<any> =>
  APIManager.sendPost(SettingsEnds.FRESHDESK_LOGIN, data, true, {}, {}, axios);

const twoFAConfig = async (data: any): Promise<any> =>
  APIManager.sendPost(SettingsEnds.TWO_FA, data, true, {}, {}, axios);

const twoFASetup = async (): Promise<any> =>
  APIManager.sendPost(SettingsEnds.TWO_FA_SETUP, {}, true, {}, {}, axios);

const verifyTOTP = async (data: any): Promise<any> =>
  APIManager.sendPost(SettingsEnds.TWO_FA_VERIFY, data, true, {}, {}, axios);

const twoFAReset = async (): Promise<any> =>
  APIManager.sendPost(SettingsEnds.TWO_FA_RESET, {}, true, {}, {}, axios);

const getRemiderList = async (): Promise<any> =>
  APIManager.sendGet(SettingsEnds.GET_ALL_REMINDERS, true, {}, {}, axios);

const addRemider = async (data: any): Promise<any> =>
  APIManager.sendPost(SettingsEnds.UPDATE_REMINDERS, data, true, {}, {}, axios);

export const SettingService = {
  getAll,
  updateCategoryStatus,
  getModulesSummary,
  freshDeskLogin,
  twoFAConfig,
  twoFASetup,
  verifyTOTP,
  twoFAReset,
  getRemiderList,
  addRemider,
};
